export const SAVE_CANDIDATE_INFO_DETAILS_REQUEST =
  "SAVE_CANDIDATE_INFO_DETAILS_REQUEST";
export const GET_CANDIDATE_INFO_DETAILS_REQUEST =
  "GET_CANDIDATE_INFO_DETAILS_REQUEST";

export const SAVE_CANDIDATE_ADDRESS_DETAILS_REQUEST =
  "SAVE_CANDIDATE_ADDRESS_DETAILS_REQUEST";
export const GET_CANDIDATE_ADDRESS_DETAILS_REQUEST =
  "GET_CANDIDATE_ADDRESS_DETAILS_REQUEST";

export const GET_LANGAUGE_DROPDOWN_DETAILS_REQUEST =
  "GET_LANGAUGE_DROPDOWN_DETAILS_REQUEST";

export const GET_CANDIDATE_SIDE_BAR_REQUEST = "GET_CANDIDATE_SIDE_BAR_REQUEST";
export const GET_CANDIDATE_JOB_PROFILE_REQUEST = "GET_CANDIDATE_JOB_PROFILE_REQUEST";

export const SAVE_CANDIDATE_KEY_SKILLS_DETAILS_REQUEST =
  "SAVE_CANDIDATE_KEY_SKILLS_DETAILS_REQUEST";

export const GET_CANDIDATE_KEY_SKILLS_DETAILS_REQUEST =
  "GET_CANDIDATE_KEY_SKILLS_DETAILS_REQUEST";

export const SAVE_CANDIDATE_LISINCE_DETAILS_REQUEST =
  "SAVE_CANDIDATE_LISINCE_DETAILS_REQUEST";
  
export const GET_CANDIDATE_LISINCE_DETAILS_REQUEST =
  "GET_CANDIDATE_LISINCE_DETAILS_REQUEST";

export const SAVE_EDUCATION_DETAILS_REQUEST = "SAVE_EDUCATION_DETAILS_REQUEST";
export const GET_EDUCATION_DETAILS_REQUEST = "GET_EDUCATION_DETAILS_REQUEST";

export const SAVE_ACCOMPLISHMENTS_DETAILS_REQUEST =
  "SAVE_ACCOMPLISHMENTS_DETAILS_REQUEST";

export const GET_ACCOMPLISHMENTS_DETAILS_REQUEST =
  "GET_ACCOMPLISHMENTS_DETAILS_REQUEST";

export const GET_DEGREE_TYPE_DROPDOWN_DETAILS_REQUEST =
  "GET_DEGREE_TYPE_DROPDOWN_DETAILS_REQUEST";


  export const GET_DOC_DETAILS_REQUEST =
  "GET_DOC_DETAILS_REQUEST";

export const SAVE_DOC_DETAILS_REQUEST =
  "SAVE_DOC_DETAILS_REQUEST";

    export const GET_JOB_PERF_DETAILS_REQUEST =
  "GET_JOB_PERF_DETAILS_REQUEST";

export const SAVE_JOB_PERF_DETAILS_REQUEST =
  "SAVE_JOB_PERF_DETAILS_REQUEST";

export const GET_NON_HOSPITAL_DROPDOWN_REQUEST =
  "GET_NON_HOSPITAL_DROPDOWN_REQUEST";


      export const GET_WORK_EXPRINCE_DETAILS_REQUEST =
  "GET_WORK_EXPRINCE_DETAILS_REQUEST";

export const SAVE_WORK_EXPRINCE_DETAILS_REQUEST =
  "SAVE_WORK_EXPRINCE_DETAILS_REQUEST";

export const GET_DESIGNATION_DROPDOWN_REQUEST =
  "GET_DESIGNATION_DROPDOWN_REQUEST";


  export const GET_EDUCATION_ACTIVE_REQUEST =
  "GET_EDUCATION_ACTIVE_REQUEST";
  
  export const GET_LINCE_ACTIVE_REQUEST =
  "GET_LINCE_ACTIVE_REQUEST";

  export const GET_WORK_EXPRINCE_ACTIVE_REQUEST =
  "GET_WORK_EXPRINCE_ACTIVE_REQUEST";

  

  
